Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocaleKey = void 0;
var _AdminListTypes = require("./AdminListTypes");
var getLocaleKey = exports.getLocaleKey = function getLocaleKey(type) {
  switch (type) {
    case _AdminListTypes.AdminListTypes.organizationMembers:
      return 'members';
    case _AdminListTypes.AdminListTypes.organizationPendingMembers:
      return 'pendingMembers';
    case _AdminListTypes.AdminListTypes.organizationTeams:
      return 'teams';
    case _AdminListTypes.AdminListTypes.teamMembers:
      return 'members';
    case _AdminListTypes.AdminListTypes.teamPendingMembers:
      return 'pendingMembers';
  }
};